'use client';

import { CssBaseline, ThemeProvider, useMediaQuery } from '@mui/material';
import { type ReactNode, useMemo } from 'react';
import { useThemeStore } from '@/stores/theme';
import { getTheme } from '@/theme';

export default function ThemeClientProvider({ children }: { children: ReactNode }) {
  const { colorMode } = useThemeStore();
  const prefersDarkMode = useMediaQuery('(prefers-color-scheme: dark)');

  const effectiveMode = colorMode === 'system' ? (prefersDarkMode ? 'dark' : 'light') : colorMode;

  const theme = useMemo(() => getTheme(effectiveMode), [effectiveMode]);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      {children}
    </ThemeProvider>
  );
}
